import React from "react";
import "./Evolution.css"; 


function Evolution() {
    return (
        <section className="about-section" id="evo">
            <div className="about-containers">
                <h2>CAPABILITY EVOLUTION</h2>
                <p>
                    At SCL, our capabilities span the complete aluminum die-casting value
                    chain—from collaborative design and engineering to high-pressure die
                    casting, precision machining, and sub-assembly. Backed by
                    state-of-the-art equipment and simulation tools, we deliver
                    lightweight, high-performance solutions to leading global automotive
                    OEMs. Our focus on quality, tool optimization, and value-added
                    processes ensures components meet the highest standards of dimensional
                    accuracy, durability, and readiness for final assembly.
                </p>
            </div>
           
        </section>
    );
}

export default Evolution;
